import type { IdentidadeObservabilidade } from '@next/compartilhados/observabilidade'

const objeto = (valor: unknown): Record<string, unknown> => (
  valor !== null && typeof valor === 'object' ? valor as Record<string, unknown> : {}
)
const texto = (valor: unknown): string | undefined => (
  typeof valor === 'string' && valor.trim() ? valor : undefined
)

/** Lê somente userInfo; não copia auth, cookies, permissões ou o cadastro inteiro. */
export const obterIdentidadeLegada = (userInfo: unknown, autenticado: boolean): IdentidadeObservabilidade | undefined => {
  if (!autenticado) return undefined
  const usuario = objeto(userInfo)
  const id = texto(usuario.id)
  if (!id) return undefined
  const email = texto(usuario.email)
  const empresa = objeto(usuario.compMan)
  const idEmpresa = texto(empresa.id)
  const nomeEmpresa = texto(empresa.name)
  return {
    usuario: { id, ...(email ? { email } : {}) },
    ...(idEmpresa ? { empresa: { id: idEmpresa, ...(nomeEmpresa ? { nome: nomeEmpresa } : {}) } } : {}),
  }
}
